module.exports = __webpack_public_path__ + "static/media/mccabe-group.98722ef9.jpg";